// @ts-ignore
import state from '../state.ts'

export default function addsReferrerPromocode() {
    const j = new URLSearchParams(window.location.search).get('jwt')
    if (j) { state.referrer.value = j }
    return (j)
}
